// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1i6UY","row":"styles_row__38Hm0","note":"styles_note__3ae-l","inUse":"styles_inUse__1uDb-","notExist":"styles_notExist__3wVM0"};